module.exports = __webpack_public_path__ + "static/media/ic_audio_activate.4d48c265.svg";